import {ModelTypes} from '@catcore/utils/json-schema';
import {FeatureParameterLandingComponent} from '@catmodules/models/feature-parameter/components/feature-parameter-landing/feature-parameter-landing.component';

const componentMap = new Map();
componentMap.set(ModelTypes.FeatureParameters, FeatureParameterLandingComponent);

export const modelFormsForWizard = componentMap;



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/shared/model-forms-for-wizard.map.ts